"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RBAClient = exports.UserActionType = exports.UserActionSeverity = exports.ImportType = exports.ScreeningBatchType = exports.AlertCaseEntityStatus = exports.AlertCaseEntityScreeningType = exports.AlertCaseStatus = exports.AlertStatus = exports.EmailType = exports.NameLanguage = exports.NameType = exports.DirectorEndReason = exports.DirectorType = exports.SecretaryEndReason = exports.CorproateStatus = exports.CorporateType = exports.IdentityType = exports.IndividualGender = exports.IndividualStatus = void 0;
class BaseInvoker {
    constructor(caller) {
        this.caller = caller;
    }
    mapWhereArgKeys(args) {
        const newArgs = args instanceof Array ? [] : {};
        for (const key in args) {
            if (Object.prototype.hasOwnProperty.call(args, key)) {
                const operators = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, WhereClauseSub), WhereClauseOperator), WhereClauseOperatorShare), WhereClauseOperatorNumber), WhereClauseOperatorString);
                const isOperator = Object.keys(operators).findIndex(op_key => op_key === key);
                const newKey = isOperator !== -1 ? Object.values(operators)[isOperator] : key;
                newArgs[newKey] =
                    args[key] instanceof Object
                        ? this.mapWhereArgKeys(args[key])
                        : args[key];
            }
        }
        return newArgs;
    }
    cleanParams(params) {
        for (const key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                if (params[key] === undefined ||
                    (params[key] &&
                        Object.keys(params[key]).length === 0 &&
                        params[key].constructor === Object)) {
                    delete params[key];
                }
            }
        }
        return params;
    }
}
class DataModelAssociateDelegate extends BaseInvoker {
    constructor(modelName, caller) {
        super(caller);
        this.modelName = modelName;
    }
    count(primaryKey, { where } = {}) {
        return new Promise((resolve, reject) => {
            this.caller
                .get(`${this.modelName}/count`.replace(':parentid', String(primaryKey)), {
                params: this.cleanParams({
                    where: this.mapWhereArgKeys(where),
                }),
            })
                .then(results => resolve(results))
                .catch(reject);
        });
    }
    add(primaryKey, foreignKey) {
        return new Promise((resolve, reject) => {
            this.caller
                .put(`${this.modelName}/:childid`
                .replace(':parentid', String(primaryKey))
                .replace(':childid', String(foreignKey)))
                .then(results => resolve(results.data))
                .catch(reject);
        });
    }
    findWhere(primaryKey, { where, limit, skip, sort, select, omit, populate, } = {}) {
        return new Promise((resolve, reject) => {
            this.caller
                .get(`${this.modelName}`.replace(':parentid', String(primaryKey)), {
                params: this.cleanParams({
                    where: this.mapWhereArgKeys(where),
                    limit,
                    skip,
                    sort,
                    select,
                    omit,
                    populate,
                }),
            })
                .then(results => resolve(results))
                .catch(reject);
        });
    }
    replace(primaryKey, foreginKeys) {
        return new Promise((resolve, reject) => {
            this.caller
                .put(`${this.modelName}`.replace(':parentid', String(primaryKey)), foreginKeys)
                .then(results => resolve(results))
                .catch(reject);
        });
    }
    removeFrom(primaryKey, foreignKey) {
        return new Promise((resolve, reject) => {
            this.caller
                .delete(`${this.modelName}/:childid`
                .replace(':parentid', String(primaryKey))
                .replace(':childid', String(foreignKey)))
                .then(results => resolve(results))
                .catch(reject);
        });
    }
}
class DataModelDelegate extends BaseInvoker {
    constructor(modelName, caller) {
        super(caller);
        this.modelName = modelName;
    }
    create(object) {
        return new Promise((resolve, reject) => {
            this.caller
                .post(`${this.modelName}`, object)
                .then(results => resolve(results))
                .catch(reject);
        });
    }
    findOne(primaryKey, { populate, select, omit, } = {}) {
        return new Promise((resolve, reject) => {
            this.caller
                .get(`${this.modelName}/${primaryKey}`, {
                params: this.cleanParams({
                    select,
                    populate,
                    omit,
                }),
            })
                .then(results => resolve(results))
                .catch(reject);
        });
    }
    findWhere({ where, limit, skip, sort, select, omit, populate, } = {}) {
        return new Promise((resolve, reject) => {
            this.caller
                .get(`${this.modelName}`, {
                params: this.cleanParams({
                    where: this.mapWhereArgKeys(where),
                    limit,
                    skip,
                    sort,
                    select,
                    omit,
                    populate,
                }),
            })
                .then(results => resolve(results))
                .catch(reject);
        });
    }
    count({ where } = {}) {
        return new Promise((resolve, reject) => {
            this.caller
                .get(`${this.modelName}/count`, {
                params: this.cleanParams({
                    where: this.mapWhereArgKeys(where),
                }),
            })
                .then(results => {
                resolve(results);
            })
                .catch(reject);
        });
    }
    update(primaryKey, objectUpdate) {
        return new Promise((resolve, reject) => {
            this.caller
                .patch(`${this.modelName}/${primaryKey}`, objectUpdate)
                .then(results => resolve(results))
                .catch(reject);
        });
    }
    destroy(primaryKey) {
        return new Promise((resolve, reject) => {
            this.caller
                .delete(`${this.modelName}/${primaryKey}`)
                .then(results => resolve(results))
                .catch(reject);
        });
    }
}
var WhereClauseOperator;
(function (WhereClauseOperator) {
    WhereClauseOperator["$NotIn"] = "nin";
    WhereClauseOperator["$In"] = "in";
})(WhereClauseOperator || (WhereClauseOperator = {}));
var WhereClauseOperatorShare;
(function (WhereClauseOperatorShare) {
    WhereClauseOperatorShare["$NotIn"] = "nin";
    WhereClauseOperatorShare["$In"] = "in";
})(WhereClauseOperatorShare || (WhereClauseOperatorShare = {}));
var WhereClauseOperatorNumber;
(function (WhereClauseOperatorNumber) {
    WhereClauseOperatorNumber["$LessThan"] = "<";
    WhereClauseOperatorNumber["$LessEqual"] = "<=";
    WhereClauseOperatorNumber["$GreaterThan"] = ">";
    WhereClauseOperatorNumber["$GreaterEqual"] = ">=";
    WhereClauseOperatorNumber["$NotEqual"] = "!=";
})(WhereClauseOperatorNumber || (WhereClauseOperatorNumber = {}));
var WhereClauseOperatorString;
(function (WhereClauseOperatorString) {
    WhereClauseOperatorString["$Contains"] = "contains";
    WhereClauseOperatorString["$StartsWith"] = "startsWith";
    WhereClauseOperatorString["$EndsWith"] = "endsWith";
})(WhereClauseOperatorString || (WhereClauseOperatorString = {}));
var WhereClauseSub;
(function (WhereClauseSub) {
    WhereClauseSub["$OR"] = "or";
    WhereClauseSub["$AND"] = "and";
})(WhereClauseSub || (WhereClauseSub = {}));
class AddressDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/addresses', caller);
    }
}
var IndividualStatus;
(function (IndividualStatus) {
    IndividualStatus[IndividualStatus["Inactive"] = 0] = "Inactive";
    IndividualStatus[IndividualStatus["Active"] = 1] = "Active";
})(IndividualStatus = exports.IndividualStatus || (exports.IndividualStatus = {}));
var IndividualGender;
(function (IndividualGender) {
    IndividualGender["Empty"] = "";
    IndividualGender["Male"] = "Male";
    IndividualGender["Female"] = "Female";
    IndividualGender["Others"] = "Others";
})(IndividualGender = exports.IndividualGender || (exports.IndividualGender = {}));
class IndividualDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/individuals', caller);
        this.name = new IndividualNameDelegate('v2/individuals/:parentid/names', caller);
        this.email = new IndividualEmailDelegate('v2/individuals/:parentid/emails', caller);
        this.address = new IndividualAddressDelegate('v2/individuals/:parentid/addresses', caller);
        this.identification = new IndividualIdentificationDelegate('v2/individuals/:parentid/identifications', caller);
        this.bank_information = new IndividualBankInformationDelegate('v2/individuals/:parentid/bank_informations', caller);
        this.attachment = new IndividualAttachmentDelegate('v2/individuals/:parentid/attachments', caller);
    }
}
class IndividualNameDelegate extends DataModelAssociateDelegate {
}
class IndividualEmailDelegate extends DataModelAssociateDelegate {
}
class IndividualAddressDelegate extends DataModelAssociateDelegate {
}
class IndividualIdentificationDelegate extends DataModelAssociateDelegate {
}
class IndividualBankInformationDelegate extends DataModelAssociateDelegate {
}
class IndividualAttachmentDelegate extends DataModelAssociateDelegate {
}
var IdentityType;
(function (IdentityType) {
    IdentityType[IdentityType["Others"] = 0] = "Others";
    IdentityType[IdentityType["HKID"] = 1] = "HKID";
    IdentityType[IdentityType["Passport"] = 2] = "Passport";
})(IdentityType = exports.IdentityType || (exports.IdentityType = {}));
var CorporateType;
(function (CorporateType) {
    CorporateType[CorporateType["PublicLimited"] = 1] = "PublicLimited";
    CorporateType[CorporateType["PrivateLimited"] = 2] = "PrivateLimited";
    CorporateType[CorporateType["LimitedByGuarantee"] = 3] = "LimitedByGuarantee";
    CorporateType[CorporateType["PublicUnlimited"] = 4] = "PublicUnlimited";
    CorporateType[CorporateType["PrivateUnlimited"] = 5] = "PrivateUnlimited";
})(CorporateType = exports.CorporateType || (exports.CorporateType = {}));
var CorproateStatus;
(function (CorproateStatus) {
    CorproateStatus[CorproateStatus["Inactive"] = 0] = "Inactive";
    CorproateStatus[CorproateStatus["Active"] = 1] = "Active";
})(CorproateStatus = exports.CorproateStatus || (exports.CorproateStatus = {}));
class CorporateDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/corporates', caller);
        this.name = new CorporateNameDelegate('v2/corporates/:parentid/names', caller);
        this.email = new CorporateEmailDelegate('v2/corporates/:parentid/emails', caller);
        this.address = new CorporateAddressDelegate('v2/corporates/:parentid/addresses', caller);
        this.bank_information = new CorporateBankInformationDelegate('v2/corporates/:parentid/bank_informations', caller);
        this.attachment = new CorporateAttachmentDelegate('v2/corporates/:parentid/attachments', caller);
        this.founder = new CorporateFounderDelegate('v2/corporates/:parentid/founders', caller);
        this.shareholder = new CorporateShareholderDelegate('v2/corporates/:parentid/shareholders', caller);
        this.secretary = new CorporateSecretaryDelegate('v2/corporates/:parentid/company_secretaries', caller);
        this.director = new CorporateDirectorDelegate('v2/corporates/:parentid/directors', caller);
        this.authorization_representative =
            new CorporateAuthorizationRepresentativeDelegate('v2/corporates/:parentid/authorization_representatives', caller);
        this.significant_controller = new CorporateSignificantControllerDelegate('v2/corporates/:parentid/significant_controllers', caller);
        this.guarantee = new CorporateGuaranteeDelegate('v2/corporates/:parentid/guarantees', caller);
    }
}
class CorporateNameDelegate extends DataModelAssociateDelegate {
}
class CorporateEmailDelegate extends DataModelAssociateDelegate {
}
class CorporateAddressDelegate extends DataModelAssociateDelegate {
}
class CorporateBankInformationDelegate extends DataModelAssociateDelegate {
}
class CorporateAttachmentDelegate extends DataModelAssociateDelegate {
}
class CorporateFounderDelegate extends DataModelAssociateDelegate {
}
class CorporateShareholderDelegate extends DataModelAssociateDelegate {
}
class CorporateSecretaryDelegate extends DataModelAssociateDelegate {
}
class CorporateDirectorDelegate extends DataModelAssociateDelegate {
}
class CorporateAuthorizationRepresentativeDelegate extends DataModelAssociateDelegate {
}
class CorporateSignificantControllerDelegate extends DataModelAssociateDelegate {
}
class CorporateGuaranteeDelegate extends DataModelAssociateDelegate {
}
var SecretaryEndReason;
(function (SecretaryEndReason) {
    SecretaryEndReason[SecretaryEndReason["None"] = 0] = "None";
    SecretaryEndReason[SecretaryEndReason["Resignation"] = 1] = "Resignation";
    SecretaryEndReason[SecretaryEndReason["Deceased"] = 2] = "Deceased";
})(SecretaryEndReason = exports.SecretaryEndReason || (exports.SecretaryEndReason = {}));
var DirectorType;
(function (DirectorType) {
    DirectorType[DirectorType["Director"] = 1] = "Director";
    DirectorType[DirectorType["AlternateDirector"] = 2] = "AlternateDirector";
    DirectorType[DirectorType["ReserveDirector"] = 3] = "ReserveDirector";
})(DirectorType = exports.DirectorType || (exports.DirectorType = {}));
var DirectorEndReason;
(function (DirectorEndReason) {
    DirectorEndReason[DirectorEndReason["Resignation"] = 1] = "Resignation";
    DirectorEndReason[DirectorEndReason["Deceased"] = 2] = "Deceased";
})(DirectorEndReason = exports.DirectorEndReason || (exports.DirectorEndReason = {}));
var NameType;
(function (NameType) {
    NameType[NameType["Basic"] = 1] = "Basic";
    NameType[NameType["Alais"] = 2] = "Alais";
    NameType[NameType["Company"] = 3] = "Company";
})(NameType = exports.NameType || (exports.NameType = {}));
var NameLanguage;
(function (NameLanguage) {
    NameLanguage[NameLanguage["Eng"] = 1] = "Eng";
    NameLanguage[NameLanguage["Chi"] = 2] = "Chi";
})(NameLanguage = exports.NameLanguage || (exports.NameLanguage = {}));
var EmailType;
(function (EmailType) {
    EmailType[EmailType["RegisteredOffice"] = 1] = "RegisteredOffice";
    EmailType[EmailType["CorrespondenceOffice"] = 2] = "CorrespondenceOffice";
    EmailType[EmailType["PrincipalBusinessOfficeInHongKong"] = 3] = "PrincipalBusinessOfficeInHongKong";
    EmailType[EmailType["PrincipalBusinessOfficeInRegisteredCountry"] = 4] = "PrincipalBusinessOfficeInRegisteredCountry";
})(EmailType = exports.EmailType || (exports.EmailType = {}));
class AttachmentDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/attachments', caller);
    }
    upload({ file, description, company_ids, person_ids, alert_ids, }) {
        const formData = new FormData();
        if (company_ids)
            formData.append('company_ids', company_ids);
        if (person_ids)
            formData.append('person_ids', person_ids);
        if (alert_ids)
            formData.append('alert_ids', alert_ids);
        if (description)
            formData.append('description', description);
        formData.append('file', file);
        return this.caller.post(`${this.modelName}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    download() { }
    view() { }
}
class AuditDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/audit_traces', caller);
    }
    destroy(primaryKey) {
        return new Promise((resolve, reject) => reject('allowed to remove'));
    }
    create(object) {
        return new Promise((resolve, reject) => reject('allowed to create'));
    }
    update(primaryKey, object) {
        return new Promise((resolve, reject) => reject('allowed to update'));
    }
}
var AlertStatus;
(function (AlertStatus) {
    AlertStatus[AlertStatus["Pending"] = 0] = "Pending";
    AlertStatus[AlertStatus["TrueHit"] = 1] = "TrueHit";
    AlertStatus[AlertStatus["FalseHit"] = 2] = "FalseHit";
})(AlertStatus = exports.AlertStatus || (exports.AlertStatus = {}));
class AlertDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/alerts', caller);
        this.audit_traces = new AuditDelegate(caller);
    }
}
var AlertCaseStatus;
(function (AlertCaseStatus) {
    AlertCaseStatus["Pending"] = "pending";
    AlertCaseStatus["Resolved"] = "resolved";
})(AlertCaseStatus = exports.AlertCaseStatus || (exports.AlertCaseStatus = {}));
class AlertCaseDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/alert_cases', caller);
        this.entities = new AlertCaseEntityAssociateDelegate('v2/alert_cases/:parentid/entities', caller);
    }
    findHistories(caseId, entityId, limit = 30, skip = 0) {
        return this.caller.get(`/v2/alert_cases/${caseId}/entities/${entityId}/histories`, { params: { limit, skip } });
    }
    countHistories(caseId, entityId) {
        return this.caller.get(`/v2/alert_cases/${caseId}/entities/${entityId}/histories/count`);
    }
}
var AlertCaseEntityScreeningType;
(function (AlertCaseEntityScreeningType) {
    AlertCaseEntityScreeningType["Onboarding"] = "onboarding";
    AlertCaseEntityScreeningType["OngoingDelta"] = "ongoing_delta";
    AlertCaseEntityScreeningType["OngoingFull"] = "ongoing_full";
})(AlertCaseEntityScreeningType = exports.AlertCaseEntityScreeningType || (exports.AlertCaseEntityScreeningType = {}));
var AlertCaseEntityStatus;
(function (AlertCaseEntityStatus) {
    AlertCaseEntityStatus[AlertCaseEntityStatus["Pending"] = 0] = "Pending";
    AlertCaseEntityStatus[AlertCaseEntityStatus["TrueHit"] = 1] = "TrueHit";
    AlertCaseEntityStatus[AlertCaseEntityStatus["FalseHit"] = 2] = "FalseHit";
})(AlertCaseEntityStatus = exports.AlertCaseEntityStatus || (exports.AlertCaseEntityStatus = {}));
class AlertCaseEntityAssociateDelegate extends DataModelAssociateDelegate {
}
class AlertCaseEntityDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/alert_case_entities', caller);
    }
    createByScreeningReviewToken(object) {
        return this.caller.post(`v2/alert_case_entities`, object);
    }
}
class SystemBatchHistoryDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/system_batch_histories', caller);
        this.log = new SystemBatchHistoryLogDelegate(caller);
    }
    destroy(primaryKey) {
        return new Promise((resolve, reject) => reject('allowed to remove'));
    }
    create(object) {
        return new Promise((resolve, reject) => reject('allowed to create'));
    }
    update(primaryKey, object) {
        return new Promise((resolve, reject) => reject('allowed to update'));
    }
}
class SystemBatchHistoryLogDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
        this.modelName = '/v2/screening/batch_log';
    }
    findWhere(primaryKey, { where, limit, skip, sort, }) {
        return new Promise((resolve, reject) => {
            this.caller
                .get('/v2/screening/batch_log/:batch_id'.replace(':batch_id', String(primaryKey)), {
                params: this.cleanParams({
                    where: this.mapWhereArgKeys(where),
                    limit,
                    skip,
                    sort,
                }),
            })
                .then(results => resolve(results))
                .catch(reject);
        });
    }
    getReportDownloadUrl(primaryKey) {
        return `/v2/screening/batch_report/${primaryKey}`;
    }
}
class AuthDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
        this.modelName = 'v1/users';
    }
    setTokenStorage({ status, data: { token, refresh, user, org, role, role_id }, }) {
        if (status === 200) {
            Cookies.set('at', RBAClient.at);
            RBAClient.at = token;
            RBAClient.rt = refresh;
            if (window.localStorage) {
                window.localStorage.setItem('at', RBAClient.at);
                window.localStorage.setItem('rt', RBAClient.rt);
            }
        }
        else {
            Cookies.remove('at');
            RBAClient.at = '';
            RBAClient.rt = '';
            if (window.localStorage) {
                window.localStorage.removeItem('at');
                window.localStorage.removeItem('rt');
            }
        }
    }
    getToken({ organization, username, password, }, config) {
        return new Promise((resolve, reject) => {
            this.caller
                .put(`${this.modelName}/login`, {
                organization,
                username,
                password,
            }, config || {})
                .then(results => {
                this.setTokenStorage(results);
                resolve(results);
            })
                .catch(reject);
        });
    }
    refreshToken(access_token, refresh_token) {
        return new Promise((resolve, reject) => {
            this.caller
                .put(`${this.modelName}/refresh`, {
                access_token,
                refresh_token,
            })
                .then(results => {
                this.setTokenStorage(results);
                resolve(results);
            })
                .catch(reject);
        });
    }
    getProfile() {
        return this.caller.get(`${this.modelName}/profile`);
    }
    forgotPassword(organization, username, email) {
        var formData = new FormData();
        formData.append('organization', organization);
        formData.append('username', username);
        formData.append('email', email);
        return this.caller.post(`api/auth/FORGOT_PASSWORD`, formData, {
            baseURL: 'https://api.rba-essential.com/'
        });
    }
    resetPassword(token, newPassword, confirmPassword) {
        var formData = new FormData();
        formData.append('token', token);
        formData.append('new_password', newPassword);
        formData.append('confirm_password', confirmPassword);
        return this.caller.post('api/auth/RESET_PASSWORD', formData, {
            baseURL: 'https://api.rba-essential.com/'
        });
    }
    verifyResetPasswordToken(token) {
        return this.caller.get(`api/auth/RESET_PASSWORD_TOKEN_VERIFY?token=${token}`, { baseURL: 'https://api.rba-essential.com/' });
    }
}
class BankInformationDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/bank_informations', caller);
    }
}
class NameDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/names', caller);
    }
}
class AuthorizedRepresentativeDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/authorized_representatives', caller);
    }
}
class DirectorDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/directors', caller);
    }
}
class EmailDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/emails', caller);
    }
}
class FounderDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/founders', caller);
    }
}
class ShareholderDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/shareholders', caller);
    }
}
class SecretaryDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/company_secretaries', caller);
    }
}
class ShareDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/shares', caller);
    }
}
class SignificantControllerDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/significant_controllers', caller);
    }
}
class IdentificationDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/identifications', caller);
    }
}
class ScreeningDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
        this.batch = new ScreeningBatchDelegate(caller);
    }
    getCountryList() {
        return this.caller.get('v2/screening/get_country_list');
    }
    getScreeningList() {
        return this.caller.get('v2/screening/get_screening_list');
    }
    getCategories() {
        return this.caller.get('v2/screening/get_categories');
    }
    riskScreening(nationality) {
        return this.caller.post('v2/screening/risks', { nationality });
    }
    nameScreening({ name, id, nationality, dob, }) {
        return this.caller.post('v2/screening/single', {
            name,
            id,
            nationality,
            dob,
        });
    }
    nameScreeningEWE(searchCriteria) {
        return this.caller.post('v2/screening/single/EWE', searchCriteria);
    }
    getScreeningResults(encryptedScanID) {
        return this.caller.get(`v2/screening/results/${btoa(encryptedScanID)}`);
    }
    getScreeningResultsEntity(encryptedScanID, entityID) {
        return this.caller.get(`v2/screening/results/${btoa(encryptedScanID)}/${entityID}`);
    }
    getScreeningResultsAssociation(encryptedScanID, entityID, ...associationIDs) {
        return this.caller.get(`v2/screening/results/${btoa(encryptedScanID)}/${entityID}/${associationIDs.join('/')}`);
    }
}
var ScreeningBatchType;
(function (ScreeningBatchType) {
    ScreeningBatchType["NewOnly"] = "new";
    ScreeningBatchType["All"] = "all";
})(ScreeningBatchType = exports.ScreeningBatchType || (exports.ScreeningBatchType = {}));
class ScreeningBatchDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
    }
    info_new_only() {
        return this.caller.get('v2/screening/batch_info_new_only');
    }
    start(batch_info) {
        return this.caller.post('v2/screening/batch_start', batch_info);
    }
    pause(batch_id) {
        return this.caller.post(`v2/screening/batch_pause/${batch_id}`);
    }
    resume(batch_id) {
        return this.caller.post(`v2/screening/batch_resume/${batch_id}`);
    }
    startEWE(batch_info) {
        return this.caller.post(`v2.1/screening/batch_start`, batch_info);
    }
    pauseEWE(batch_id) {
        return this.caller.post(`v2.1/screening/batch_pause/${batch_id}`);
    }
    resumeEWE(batch_id) {
        return this.caller.post(`v2.1/screening/batch_resume/${batch_id}`);
    }
}
class TransactionDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/transactions', caller);
    }
}
var ImportType;
(function (ImportType) {
    ImportType["Company"] = "company";
    ImportType["Person"] = "person";
})(ImportType = exports.ImportType || (exports.ImportType = {}));
class ImportDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
    }
    importXLSX(type, file) {
        const formData = new FormData();
        formData.append('excel', file);
        return this.caller.post(`v2/imports/${type}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    importDesktopDatabase(file) {
        const formData = new FormData();
        formData.append('accdb', file);
        return this.caller.post(`v2/imports/desktop-migration`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    importLinksoftIndividual(file) {
        return this.importXLSX('linksoft/individual', file);
    }
}
class EkycDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
        this.client = new EkycClientDelegate(caller);
        this.request = new EkycRequestDelegate(caller);
        this.document = new EkycDocumentDelegate(caller);
        this.thread = new EkycThreadDelegate(caller);
    }
    getBankList() {
        return this.caller('v2/ekyc/banks');
    }
}
class EkycClientDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
    }
    findOne(ekycClientId) {
        return this.caller.get(`v2/ekyc/clients/${ekycClientId}`);
    }
    findWhere({ limit, skip }) {
        return this.caller.get(`v2/ekyc/clients`, { params: { limit, skip } });
    }
    create(primaryKey) {
        return this.caller.post(`v2/ekyc/clients`, { company_id: primaryKey });
    }
}
class EkycRequestDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
    }
    find(ekycClientId, { limit, skip }) {
        return this.caller.get(`v2/ekyc/clients/${ekycClientId}/requests`, { params: { limit, skip } });
    }
    create(ekycClientId, banks, documents, message) {
        return this.caller.post(`v2/ekyc/requests`, { ekyc_client_id: ekycClientId, banks, documents, message });
    }
    update(ekycRequestRef, documentsAdd, documentsRemove, isCancel) {
        return this.caller.patch(`v2/ekyc/requests/${ekycRequestRef}`, { documents_add: documentsAdd, documents_remove: documentsRemove, is_cancel: isCancel });
    }
}
class EkycDocumentDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
    }
    find(ekycClientId, { limit, skip }) {
        return this.caller.get(`v2/ekyc/documents/${ekycClientId}`, { params: { limit, skip } });
    }
    upload(ekycClientId, description, file) {
        const formData = new FormData();
        if (ekycClientId)
            formData.append('ekyc_client_id', ekycClientId);
        if (description)
            formData.append('description', description);
        formData.append('file', file);
        return this.caller.post(`v2/ekyc/documents`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    uploadExist(companyId, attachmentIds) {
        return this.caller.post(`v2/ekyc/documents/exist`, { company_id: companyId, attachment_ids: attachmentIds });
    }
    verify(ekycClientId, attachmentId) {
        return this.caller.post(`v2/ekyc/documents/verify`, { ekyc_client_id: ekycClientId, attachment_id: attachmentId });
    }
}
class EkycThreadDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
    }
    findOne(ekycRequestId) {
        return this.caller.get(`v2/ekyc/threads/${ekycRequestId}`);
    }
    create(ekycRequestId, message) {
        return this.caller.post(`v2/ekyc/threads/${ekycRequestId}`, { message });
    }
}
var UserActionSeverity;
(function (UserActionSeverity) {
    UserActionSeverity["Normal"] = "normal";
    UserActionSeverity["Medium"] = "medium";
    UserActionSeverity["High"] = "high";
})(UserActionSeverity = exports.UserActionSeverity || (exports.UserActionSeverity = {}));
var UserActionType;
(function (UserActionType) {
    UserActionType["NaturalPerson_Create"] = "naturalperson.create";
    UserActionType["NaturalPerson_Update"] = "naturalperson.update";
    UserActionType["NaturalPerson_Delete"] = "naturalperson.delete";
    UserActionType["NaturalPerson_Export"] = "naturalperson.export";
    UserActionType["Company_Create"] = "company.create";
    UserActionType["Company_Update"] = "company.update";
    UserActionType["Company_Delete"] = "company.delete";
    UserActionType["Company_Export"] = "company.export";
    UserActionType["Transaction_Create"] = "transaction.create";
    UserActionType["Transaction_Update"] = "transaction.update";
    UserActionType["Transaction_Delete"] = "transaction.delete";
    UserActionType["Transaction_Download"] = "transaction.download";
    UserActionType["Alert_Resolve"] = "alert.resolve";
    UserActionType["Alert_Modify"] = "alert.modify";
    UserActionType["NameScreening_Single"] = "name_screening.single";
    UserActionType["NameScreening_Onboarding"] = "name_screening.onboarding";
    UserActionType["NameScreening_Batch_Start"] = "name_screening.batch.start";
    UserActionType["NameScreening_Batch_Stop"] = "name_screening.batch.stop";
    UserActionType["NameScreening_Batch_End"] = "name_screening.batch.end";
    UserActionType["NameScreening_Batch_Export"] = "name_screening.batch.export";
    UserActionType["DataImport_Company"] = "import.company";
    UserActionType["DataImport_NaturalPerson"] = "import.naturalperson";
})(UserActionType = exports.UserActionType || (exports.UserActionType = {}));
class UserActionLogDelegate extends DataModelDelegate {
    constructor(caller) {
        super('v2/users/activity', caller);
    }
    findUsernames() {
        return this.caller.get(`${this.modelName}/usernames`);
    }
}
class SettingsDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
    }
    getApplicationVersion() {
        return this.caller.get(`v2/app/version`);
    }
}
class CrFormDelegate extends BaseInvoker {
    constructor(caller) {
        super(caller);
    }
    getCrFormDownloadUrl(formNames, companyId, nominatedDirectorIds, suspendedDirectorIds, nominatedSecretaryIds, suspendedSecretaryIds, authRepsIds) {
        const queryString = new URLSearchParams();
        if (formNames) {
            formNames.forEach(formName => {
                queryString.append('form_names', formName);
            });
        }
        if (companyId)
            queryString.append('company_id', companyId);
        if ((nominatedDirectorIds || suspendedDirectorIds) && (formNames.includes('ND5') || formNames.includes('ND2A') || formNames.includes('NN8') ||
            formNames.includes('ND7') || formNames.includes('ND2B') || formNames.includes('NN7'))) {
            nominatedDirectorIds === null || nominatedDirectorIds === void 0 ? void 0 : nominatedDirectorIds.forEach(directorId => {
                queryString.append('nominated_director_ids', directorId);
            });
            suspendedDirectorIds === null || suspendedDirectorIds === void 0 ? void 0 : suspendedDirectorIds.forEach(directorId => {
                queryString.append('suspended_director_ids', directorId);
            });
        }
        if ((nominatedSecretaryIds || suspendedSecretaryIds) && (formNames.includes('ND2A') || formNames.includes('NN6') ||
            formNames.includes('ND2B') || formNames.includes('NN7'))) {
            nominatedSecretaryIds === null || nominatedSecretaryIds === void 0 ? void 0 : nominatedSecretaryIds.forEach(secretaryId => {
                queryString.append('nominated_secretary_ids', secretaryId);
            });
            suspendedSecretaryIds === null || suspendedSecretaryIds === void 0 ? void 0 : suspendedSecretaryIds.forEach(secretaryId => {
                queryString.append('suspended_secretary_ids', secretaryId);
            });
        }
        if (authRepsIds && (formNames.includes('NN8C') || formNames.includes('NN8'))) {
            authRepsIds.forEach(authRepsId => {
                3;
                queryString.append('auth_reps_ids', authRepsId);
            });
        }
        return `/v2/crform/generate?${queryString}`;
    }
}
const axios_1 = require("axios");
const EventEmitter = require("events");
const Cookies = require('js-cookie');
class RBAClient {
    constructor(options, listeners) {
        this.axios = axios_1.default.create(options);
        this.setupTokenPair();
        window.addEventListener('storage', () => {
            RBAClient.refreshing = window.localStorage.getItem('refreshing') === 'true';
            if (!RBAClient.refreshing) {
                RBAClient.bus.emit('refreshed');
            }
            this.setupTokenPair();
        });
        RBAClient.bindListeners(listeners);
        this.axios.interceptors.request.use(config => {
            if (RBAClient.at && RBAClient.at.length > 0) {
                config.headers['Authorization'] = `Bearer ${RBAClient.at}`;
            }
            return config;
        }, error => {
            return Promise.reject(error);
        });
        this.axios.interceptors.response.use(response => {
            return response;
        }, (error) => __awaiter(this, void 0, void 0, function* () {
            const originalRequest = error.config;
            if (error.response.status === 401 &&
                ['v1/users/login', 'v1/users/refresh'].indexOf(error.config.url.trim('/')) === -1) {
                if (RBAClient.refreshing) {
                    yield new Promise((resolve, reject) => {
                        let timer = setTimeout(() => {
                            reject();
                        }, 8000);
                        RBAClient.bus.once('refreshed', () => {
                            timer && clearTimeout(timer);
                            resolve();
                        });
                    });
                    return this.axios(originalRequest);
                }
                else {
                    try {
                        RBAClient.refreshing = true;
                        window.localStorage.setItem('refreshing', 'true');
                        RBAClient.bus.emit('refreshing');
                        const results = yield this.auth.refreshToken(RBAClient.at, RBAClient.rt);
                        RBAClient.refreshing = false;
                        window.localStorage.setItem('refreshing', 'false');
                        RBAClient.bus.emit('refreshed');
                        if (RBAClient.at && RBAClient.rt) {
                            return this.axios(originalRequest);
                        }
                        else {
                            throw new Error('access token refresh failed');
                        }
                    }
                    catch (error) {
                        RBAClient.refreshing = false;
                        window.localStorage.setItem('refreshing', 'false');
                        RBAClient.bus.emit('refreshFailed');
                        return Promise.reject(error);
                    }
                }
            }
            return Promise.reject(error);
        }));
        this.address = new AddressDelegate(this.axios);
        this.individual = new IndividualDelegate(this.axios);
        this.corporate = new CorporateDelegate(this.axios);
        this.alert = new AlertDelegate(this.axios);
        this.alert_case = new AlertCaseDelegate(this.axios);
        this.alert_case_entity = new AlertCaseEntityDelegate(this.axios);
        this.attachment = new AttachmentDelegate(this.axios);
        this.bank_information = new BankInformationDelegate(this.axios);
        this.name = new NameDelegate(this.axios);
        this.authorized_representative = new AuthorizedRepresentativeDelegate(this.axios);
        this.director = new DirectorDelegate(this.axios);
        this.email = new EmailDelegate(this.axios);
        this.founder = new FounderDelegate(this.axios);
        this.shareholder = new ShareholderDelegate(this.axios);
        this.secretary = new SecretaryDelegate(this.axios);
        this.share = new ShareDelegate(this.axios);
        this.significant_controller = new SignificantControllerDelegate(this.axios);
        this.identification = new IdentificationDelegate(this.axios);
        this.transaction = new TransactionDelegate(this.axios);
        this.system_batch_history = new SystemBatchHistoryDelegate(this.axios);
        this.audit_traces = new AuditDelegate(this.axios);
        this.action_log = new UserActionLogDelegate(this.axios);
        this.cr_form = new CrFormDelegate(this.axios);
        this.screen = new ScreeningDelegate(this.axios);
        this.auth = new AuthDelegate(this.axios);
        this.importer = new ImportDelegate(this.axios);
        this.ekyc = new EkycDelegate(this.axios);
        this.settings = new SettingsDelegate(this.axios);
    }
    static getInstance(options, listeners) {
        if (this._instance) {
            this.bindListeners(listeners);
        }
        return this._instance || (this._instance = new this(options, listeners));
    }
    static bindListeners(listeners) {
        if (listeners === null || listeners === void 0 ? void 0 : listeners.onTokenRefresh)
            RBAClient.bus.on('refreshing', listeners.onTokenRefresh);
        if (listeners === null || listeners === void 0 ? void 0 : listeners.onTokenRefreshed)
            RBAClient.bus.on('refreshed', listeners.onTokenRefreshed);
        if (listeners === null || listeners === void 0 ? void 0 : listeners.onTokenRefreshFailed)
            RBAClient.bus.on('refreshFailed', listeners.onTokenRefreshFailed);
        if (listeners === null || listeners === void 0 ? void 0 : listeners.onTokenSet)
            RBAClient.bus.on('tokenSet', listeners.onTokenSet);
        if (listeners === null || listeners === void 0 ? void 0 : listeners.onTokenRemove)
            RBAClient.bus.on('tokenRemove', listeners.onTokenRemove);
    }
    setupTokenPair() {
        try {
            RBAClient.at = String(window.localStorage.getItem('at') &&
                window.localStorage.getItem('at') !== 'null'
                ? window.localStorage.getItem('at')
                : '');
            RBAClient.rt = String(window.localStorage.getItem('rt') &&
                window.localStorage.getItem('rt') !== 'null'
                ? window.localStorage.getItem('rt')
                : '');
            Cookies.set('at', RBAClient.at);
            if (!RBAClient.at && !RBAClient.rt) {
                RBAClient.bus.emit('tokenRemove');
            }
            else {
                RBAClient.bus.emit('tokenSet', {
                    accessToken: RBAClient.at
                });
            }
        }
        catch (error) {
            console.warn(error);
        }
    }
}
exports.RBAClient = RBAClient;
RBAClient.bus = new EventEmitter.EventEmitter();
RBAClient.refreshing = false;
//# sourceMappingURL=index.js.map